export default __webpack_public_path__ + "static/monnify-dev-2-d339fd6a09e9f6b8b0f4cbcbad750e69.svg";